module.exports = __webpack_public_path__ + "assets/img/four.png?d4631c9d96665ffb36cba2f83c0fc43a";